import { ErrorEvent } from '@sentry/types';
import stringify from 'json-stringify-safe';

export const MAX_EXTRA_DATA_LENGTH = 1024 * 100;

export const removeExtraData = (event: ErrorEvent): void => {
    // Обрезаем extra когда слишком много информации, см. https://jira.hh.ru/browse/HH-69844
    const extraDataLength = stringify(event.extra).length;
    if (extraDataLength > MAX_EXTRA_DATA_LENGTH) {
        event.extra = {
            __removed: `${'Extra data is too large and has been stripped ('}${extraDataLength}/${MAX_EXTRA_DATA_LENGTH})`,
        };
    }
};
